module.exports = __webpack_public_path__ + "media/bootstrap-icons/code-slash-99b931e8.svg";